module.exports = __webpack_public_path__ + "img/a43f889.jpg";